import 'antd/dist/reset.css';
import './App.css';
import './styles/ai.css';

import { NavConfigProvider } from './context/NavContext';
import { PageProvider, PAGES, usePage } from './context/PageContext';
import TopNav from './components/TopNav';
import Footer from './components/Footer';
import ScrollProgress from './components/ScrollProgress';

import HomePage from './pages/HomePage';
import ResearchOverviewPage from './pages/ResearchOverviewPage';
import ResearchAgentPage from './pages/ResearchAgentPage';
import MedicalAIPage from './pages/MedicalAIPage';
import LifeSciencePage from './pages/LifeSciencePage';
import MathPage from './pages/MathPage';
import PowerIntelligencePage from './pages/PowerIntelligencePage';
import UpdatesPage from './pages/UpdatesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import TeamPage from './pages/TeamPage';
import ArckPage from './pages/ArckPage';
import NotFoundPage from './pages/NotFoundPage';

/* state 驱动的页面分发：根据 currentPage 渲染对应组件，
   完全替代原来的 <Routes><Route .../></Routes>。 */
function PageOutlet() {
    const { currentPage } = usePage();
    switch (currentPage) {
        case PAGES.HOME:
            return <HomePage />;
        case PAGES.RESEARCH:
            return <ResearchOverviewPage />;
        case PAGES.RESEARCH_LLM:
            return <ResearchAgentPage />;
        case PAGES.RESEARCH_MEDICAL:
            return <MedicalAIPage />;
        case PAGES.RESEARCH_LIFE:
            return <LifeSciencePage />;
        case PAGES.RESEARCH_MATH:
            return <MathPage />;
        case PAGES.RESEARCH_POWER:
            return <PowerIntelligencePage />;
        case PAGES.UPDATES:
            return <UpdatesPage />;
        case PAGES.ARTICLE_DETAIL:
            return <ArticleDetailPage />;
        case PAGES.TEAM:
            return <TeamPage />;
        case PAGES.ARCK:
            return <ArckPage />;
        case PAGES.NOT_FOUND:
        default:
            return <NotFoundPage />;
    }
}

function App() {
    console.log('[App] mounted');
    return (
        <PageProvider>
            <NavConfigProvider>
                <TopNav />
                <ScrollProgress />
                <main className="app-main">
                    <PageOutlet />
                </main>
                <Footer />
            </NavConfigProvider>
        </PageProvider>
    );
}

export default App;
